module.exports = __webpack_public_path__ + "img/inventory_tracking.9e0fb0f8.svg";